import { RefObject, useEffect, useRef } from "react";

const hasNestedErrors = (errors: unknown): boolean => {
    if (!errors) {
        return false;
    }
    if (typeof errors === "string") {
        return true;
    }
    if (Array.isArray(errors)) {
        return errors.some((item) => hasNestedErrors(item));
    }
    if (typeof errors === "object") {
        return Object.values(errors as Record<string, unknown>).some((value) => hasNestedErrors(value));
    }
    return false;
};

const useScrollToFormError = (
    formRef: RefObject<HTMLFormElement>,
    errors: unknown,
    submitCount: number
) => {
    const lastSubmitCountWithError = useRef(0);

    useEffect(() => {
        if (!hasNestedErrors(errors)) {
            return;
        }

        if (submitCount <= lastSubmitCountWithError.current) {
            return;
        }

        lastSubmitCountWithError.current = submitCount;

        const timeoutId = window.setTimeout(() => {
            const form = formRef.current;
            if (!form) {
                return;
            }

            const errorElement = form.querySelector(
                ".text-message-error"
            ) as HTMLElement | null;

            if (errorElement) {
                errorElement.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                });
            }
        }, 0);

        return () => window.clearTimeout(timeoutId);
    }, [errors, formRef, submitCount]);
};

export default useScrollToFormError;
